<template>
  <v-container fluid class="user-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-tabs
          color="primary"
        >
          <v-tab
            :href="`#tab-account`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-account-outline</v-icon>
            User
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-photo`"
          >
            <v-icon class="mr-3">mdi-camera</v-icon>
            Photo
          </v-tab>
          <v-tab
            :href="`#tab-options`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-account-cog</v-icon>
            Options
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-password`"
          >
            <v-icon class="mr-3">mdi-lock</v-icon>
            Change Password
          </v-tab>
          <v-tab-item
            :value="'tab-account'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="3" sm="6">
                    <v-form>
                      <p class="text-h5">Edit User</p>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="onChangeUser($event, 'username')"
                        v-bind:value="initvalue.username"
                        placeholder="User Name"
                        persistent-hint
                        single-line hint="Enter the user name">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="onChangeUser($event, 'userid')"
                        v-bind:value="initvalue.userid"
                        placeholder="User Id"
                        persistent-hint
                        single-line hint="Enter the user id">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="onChangeUser($event, 'useremail')"
                        v-bind:value="initvalue.useremail"
                        placeholder="User Email"
                        persistent-hint
                        single-line hint="Enter user email address">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="onChangeUser($event, 'usermobile')"
                        v-bind:value="initvalue.usermobile"
                        placeholder="Mobile Number"
                        persistent-hint
                        single-line hint="Enter the mobile number">
                      </v-text-field>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3" sm="6">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-select
                        class="mb-4"
                        :items="locations.map(x => {return {text: x.locationname, value: x._id};})"
                        :value="initvalue.locationid"
                        outlined
                        dense
                        v-on:change="onChangeUser($event, 'locationid')"
                        placeholder="Location"
                        persistent-hint
                        single-line hint="Please choose the location">
                      </v-select>
                      <v-select
                        class="mb-4"
                        :items="saleschannels.map(x => {return {text: x.channelname, value: x._id};})"
                        :value="initvalue.channelid"
                        outlined
                        dense
                        v-on:change="onChangeUser($event, 'channelid')"
                        placeholder="Channel"
                        persistent-hint
                        single-line hint="Please choose the channel">
                      </v-select>
                      <v-select
                        class="mb-4"
                        :items="roles.map(x => {return {text: x.rolecode, value: x._id};})"
                        :value="initvalue.roleid"
                        outlined
                        dense
                        v-on:change="onChangeUser($event, 'roleid')"
                        placeholder="Role"
                        persistent-hint
                        single-line hint="Please choose the role">
                      </v-select>
                      <v-select
                        class="mb-4"
                        :items="menus.map(x => {return {text: x.menuname, value: x._id};})"
                        :value="initvalue.menuid"
                        outlined
                        dense
                        v-on:change="onChangeUser($event, 'menuid')"
                        placeholder="Menu"
                        persistent-hint
                        single-line hint="Please choose the menu">
                      </v-select>
                      <v-select
                        class="mb-4"
                        :items=usertypes
                        :value="initvalue.usertype"
                        outlined
                        dense
                        v-on:change="onChangeUser($event, 'usertype')"
                        placeholder="Type"
                        persistent-hint
                        single-line hint="Please choose the user type">
                      </v-select>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3" sm="6">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-switch
                          color="primary"
                          v-on:change="onChangeUser($event, 'userstatus')"
                          v-bind:label="initvalue.userstatus"
                          v-model="initvalue.userstatus"
                          value="Active"
                          false-value="Inactive"
                          hint="Status"
                          persistent-hint
                      ></v-switch>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="9">
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/user/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editUser()">
                            Save
                          </v-btn>
                      </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item
              :value="'tab-photo'"
          >
            <v-card
                flat
                tile
            >
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="6">
                    <v-form>
                      <p class="text-h5">Upload Photo</p>
                        <v-file-input label="File input" v-on:change="onChangeFile" accept="image/*" />
                        <v-img contain max-height="150" max-width="250" :src="imageurl" />
                        <v-spacer min-height="20">&nbsp;</v-spacer>
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/user/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editUserPhoto()">
                            Save
                          </v-btn>
                      </div>
                    </v-form>
                  </v-col>
                </v-row>

              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item
            :value="'tab-options'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row justify="center" class="no-gutters">
                  <v-col cols="12" md="6"><p class="text-h5">Edit Options</p></v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="2">
                    <v-form>
                      <div style="padding: 5px;"></div>
                      <v-text-field
                        type="number"
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="onChangeOptions($event, 'userrate')"
                        v-bind:value="edit_user.options ? edit_user.options.userrate : null"
                        placeholder="Hourly Rate"
                        persistent-hint
                        single-line hint="Enter the rate">
                      </v-text-field>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="1">
                    <v-form>
                      <v-switch
                          color="primary"
                          v-on:change="onChangeOptions($event, 'isAllCustomers')"
                          v-model="edit_user.options.isAllCustomers"
                          v-bind:value="edit_user.options ? edit_user.options.isAllCustomers : false"
                          hint="All Customers"
                          :false-value="false"
                          persistent-hint
                      ></v-switch>
                      <v-switch
                          color="primary"
                          v-on:change="onChangeOptions($event, 'isAllVendors')"
                          v-model="edit_user.options.isAllVendors"
                          v-bind:value="edit_user.options ? edit_user.options.isAllVendors : false"
                          hint="All Vendors"
                          :false-value="false"
                          persistent-hint
                      ></v-switch>
                      <v-switch
                          color="primary"
                          v-on:change="onChangeOptions($event, 'isAllSalesOrders')"
                          v-model="edit_user.options.isAllSalesOrders"
                          v-bind:value="edit_user.options ? edit_user.options.isAllSalesOrders : false"
                          hint="All Sales Orders"
                          :false-value="false"
                          persistent-hint
                      ></v-switch>
                      <v-switch
                          color="primary"
                          v-on:change="onChangeOptions($event, 'isAllBills')"
                          v-model="edit_user.options.isAllBills"
                          v-bind:value="edit_user.options ? edit_user.options.isAllBills : false"
                          hint="All Bills"
                          persistent-hint
                      ></v-switch>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="1">
                    <v-form>
                      <v-switch
                          color="primary"
                          v-on:change="onChangeOptions($event, 'isApprover')"
                          v-model="edit_user.options.isApprover"
                          v-bind:value="edit_user.options ? edit_user.options.isApprover : false"
                          hint="Approver"
                          persistent-hint
                      ></v-switch>
                      <v-switch
                          color="primary"
                          v-on:change="onChangeOptions($event, 'isAdminProject')"
                          v-model="edit_user.options.isAdminProject"
                          v-bind:value="edit_user.options ? edit_user.options.isAdminProject : false"
                          hint="Admin Project"
                          persistent-hint
                      ></v-switch>
                      <v-switch
                          color="primary"
                          v-on:change="onChangeOptions($event, 'isBusinessProject')"
                          v-model="edit_user.options.isBusinessProject"
                          v-bind:value="edit_user.options ? edit_user.options.isBusinessProject : false"
                          hint="Business Project"
                          persistent-hint
                      ></v-switch>
                      <v-switch
                          color="primary"
                          v-on:change="onChangeOptions($event, 'isCreativeProject')"
                          v-model="edit_user.options.isCreativeProject"
                          v-bind:value="edit_user.options ? edit_user.options.isCreativeProject : false"
                          hint="Creative Project"
                          persistent-hint
                      ></v-switch>
                      <v-switch
                          color="primary"
                          v-on:change="onChangeOptions($event, 'isMarketProject')"
                          v-model="edit_user.options.isMarketProject"
                          v-bind:value="edit_user.options ? edit_user.options.isMarketProject : false"
                          hint="Marketing Project"
                          persistent-hint
                      ></v-switch>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="1">
                    <v-form>
                      <v-switch
                          color="primary"
                          v-on:change="onChangeOptions($event, 'isGeolocation')"
                          v-model="edit_user.options.isGeolocation"
                          v-bind:value="edit_user.options ? edit_user.options.isGeolocation : false"
                          hint="Track Geolocation"
                          persistent-hint
                      ></v-switch>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="6">
                    <div class="d-flex justify-center">
                        <v-btn
                            to="/user/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editUserOptionsRequest()">
                            Save
                          </v-btn>
                      </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item
              :value="'tab-password'"
          >
            <v-card
                flat
                tile
            >
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="6">
                    <v-form>
                      <p class="text-h5">Change Password</p>
                      <v-text-field
                      
                          type="password"
                          class="mb-4"
                          outlined
                          dense
                          value=""
                          v-model="password.userpassword"
                          v-bind:error="password.error"
                          placeholder="New Password"
                          persistent-hint
                          single-line hint="Enter user password. Min 6 digits long">
                      </v-text-field>
                      <v-text-field
                          type="password"
                          class="mb-4"
                          outlined
                          dense
                          value=""
                          v-model="password.userpassword2"
                          v-bind:error="password.error2"
                          placeholder="Verify Password"
                          persistent-hint
                          single-line hint="Confirm user password. Min 6 digits long">
                      </v-text-field>
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/user/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editPassword()">
                            Save
                          </v-btn>
                      </div>
                    </v-form>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';
export default {
  computed: {
    ...mapState('Location', ['locations']),
    ...mapState('Menu', ['menus']),
    ...mapState('Role', ['roles']),
    ...mapState('SalesChannel', ['saleschannels']),
    ...mapState('User', ['isReceiving']),
  },
  data () {
    return {
        password: {
            error: false,
            error2: false
        },
        change_options: {},
        edit_user: {},
        edit_photo: {},
        edit_userpassword: {},
        error: [
            {code: 0, name: "username"},
            {code: 1, name: "roleid"}
        ],
        errorcode: undefined,
        initvalue: {},
        imageurl: undefined,
        data_users: [],
        usertypes: ['System Administrator', 'Company Administrator', 'Sales Representative', 'Sales Driver', 'Graphic Designer', 'Content Creator'],
    };
  },
  async created () {
    this.initvalue = this.$route.params;
    this.edit_user = Object.assign({}, this.initvalue);
    if(!this.edit_user.options) this.edit_user.options = {};
    if(!this.initvalue._id) this.$router.push({name: 'UserList'});
    this.imageurl = this.initvalue.userimage;

    if(this.locations.length==0) await this.getLocationsRequest();
    if(this.menus.length==0) await this.getMenusRequest();
    if(this.roles.length==0) await this.getRolesRequest();
    if(this.saleschannels.length==0) await this.getSalesChannelsRequest();
    

    this.password.userpassword = undefined;
    this.password.userpassword2 = undefined;
  },
  methods: {
    ...mapActions('Location', ['getLocationsRequest']),
    ...mapActions('Menu', ['getMenusRequest']),
    ...mapActions('Role', ['getRolesRequest']),
    ...mapActions('SalesChannel', ['getSalesChannelsRequest']),
    ...mapActions('User', ['updateUserRequest', 'updateUserOptionsRequest', 'updateUserImageRequest','updateUserPasswordRequest','getUsersRequest']),
    async editUser() {
      this.edit_user._id = this.initvalue._id;
      await this.updateUserRequest(this.edit_user);
      router.push('/user/list');
    },
    editUserPhoto() {
      this.edit_photo._id = this.initvalue._id;
      this.updateUserImageRequest(this.edit_photo);
      this.getUsersRequest();
      router.push('/user/list');
    },
    async editUserOptionsRequest() {
      this.change_options._id = this.initvalue._id;
      console.log(this.change_options)
      await this.updateUserOptionsRequest(this.change_options);
      router.push('/user/list');
    },
    onChangeFile(file) {
      if (!file) {return;}
      this.edit_photo.userimage = file;
      this.edit_photo.imagename = file.name;
      const reader = new FileReader();
      reader.onload = e => {
        this.imageurl = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    onChangeUser(value, field){
      this.edit_user[field] = value;
    },
    onChangeOptions(value, field){
      console.log(value, field)
      this.change_options[field] = value;
    },
    editPassword() {
      if(this.password.userpassword == undefined || this.password.userpassword.length<6){
        this.password.error = true;
        return;
      }
      this.password.error = false;
      if(this.password.userpassword !== this.password.userpassword2){
        this.password.error2 = true;
        return;
      }
      this.password.error2 = false;
      this.password._id = this.initvalue._id;
      this.updateUserPasswordRequest(this.password);
      this.getUsersRequest();
      router.push('/user/list');
    },
  },

}
</script>

<style src="./Edit.scss" lang="scss"></style>
